import { testnetAddresses } from '../testnetAddresses';
import { tokens } from '../../tokens/underlyingTokens';
import { ChainId, type VToken } from '../../types';

export const bittensorTestnet: VToken[] = [
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vWsTAO,
    decimals: 8,
    symbol: 'vWsTAO',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][7]!,
  },
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vAlpha30,
    decimals: 8,
    symbol: 'vALPHA30',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][2]!,
  },
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vAlpha64,
    decimals: 8,
    symbol: 'vALPHA64',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][3]!,
  },
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vWAlpha288V2,
    decimals: 8,
    symbol: 'vWAlpha288',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][4]!,
  },
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vWAlpha333V2,
    decimals: 8,
    symbol: 'vWAlpha333',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][5]!,
  },
  {
    chainId: ChainId.BITTENSOR_TESTNET,
    address: testnetAddresses.vWAlpha418V2,
    decimals: 8,
    symbol: 'vWAlpha418',
    underlyingToken: tokens[ChainId.BITTENSOR_TESTNET][6]!,
  },
];
